import type { SdkResourceField } from '@Pages/pageRuntime/sdk/types';

type FieldLabelProps = {
  /**
   * A resource field handle from the resource catalog (`resource.fields.someField`).
   * Its `label` is rendered as the field's display name.
   */
  field: SdkResourceField;

  className?: string;
};

/**
 * Renders a resource field's label. Declared at module scope so its component
 * identity is always stable across renders without needing to be memoized.
 */
export function FormFieldLabel({ field, className }: FieldLabelProps) {
  return <span className={className}>{field.label}</span>;
}
